// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__BdQPF","button":"styles_button__XgHPz","overlay":"styles_overlay__AGHfS"};